import React from 'react';
import classnames from 'classnames';
import s from './GroupLinkLoader.scss';
const GroupLinkLoader = ({ className , isCollapsed  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isCollapsed && s['collapsed'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['avatar']
    }), !isCollapsed && /*#__PURE__*/ React.createElement("div", {
        className: s['username']
    }));
};
GroupLinkLoader.displayName = 'GroupLinkLoader';
export default GroupLinkLoader;
